import { configureStore } from '@reduxjs/toolkit';
import breadcrumSlice from './breadcrumSlice';
import commonSlice from './commonSlice';
import mobileSideBar from './mobileSideBar';
import themeSlice from './themeSlice';
import AskLocationSlice from './AskLocationSlice';

const store = configureStore({
    reducer: {
        breadcrumSlice: breadcrumSlice,
        commonSlice:commonSlice,
        mobileSideBar:mobileSideBar,
        themeSlice:themeSlice,
        AskLocationSlice:AskLocationSlice
    },
});

export default store;